import { render } from "./pricingpage.vue?vue&type=template&id=54cdec24&scoped=true"
import script from "./pricingpage.vue?vue&type=script&lang=js"
export * from "./pricingpage.vue?vue&type=script&lang=js"

import "./pricingpage.vue?vue&type=style&index=0&id=54cdec24&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cdec24"]])

export default __exports__